import { Document, Image, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const gender = {
	Female: "a",
	Male: "o",
	Other: "e",
}

const styles = StyleSheet.create({
	page: { padding: 72 },
	title: { fontFamily: 'Helvetica', textAlign: 'center', fontSize: 16, marginBottom: 10, marginTop: 10 },
	text: { fontFamily: 'Helvetica', marginBottom: 10, fontSize: 10, lineHeight: 1.3 },
	listItem: { fontFamily: 'Helvetica', marginBottom: 10, fontSize: 10, lineHeight: 1.5, marginLeft: 20 },
	bold: { fontFamily: 'Helvetica-Bold'},	
	italic: {fontFamily: 'Helvetica-Oblique'}
});


export function ResponsibleDeclaration(props, signatureImg, declaration) {
	console.log("AGAIN DECLARATION", declaration)
	return (
	<>
	  <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>A la Oficina de Extranjería en {props.province2}</Text>
                <Text style={styles.title}>DECLARACIÓN RESPONSABLE</Text>
				<Text style={styles.text}>
					{props.fullName} ciudadan{gender[props.gender]}, mayor de edad, de nacionalidad {props.citizenship1}, residente en {props.postalCode}-{props.city}, con domicilio en {props.address}, en mi propio nombre y derecho comparezco ante este órgano administrativo y, como mejor proceda en Derecho,
				</Text>
				<Text style={styles.title}>DIGO:</Text>
				<br />
				<br />
				<Text style={styles.text}>
				Que por medio del presente, que adjunto a mi solicitud, en virtud del artículo 69.1 y 3 de la Ley de 1 de octubre, del Procedimiento Administrativo Común de las Administraciones Públicas (en adelante, la “LPACAP”), y en relación con los requisitos establecidos en la normativa aplicable de dicha solicitud, BAJO MI PROPIA RESPONSABILIDAD,
				</Text>
				<Text style={styles.title}>DECLARO:</Text>
				<br />
				<Text style={styles.text}>
				<b>Primero.</b> – Que {declaration}
				</Text>
				<br />
				<Text style={styles.text}>
				<b>Segundo.</b> – Que dispongo o, en su caso, puedo disponer de la documentación que así lo acredita, que, sin perjuicio de lo establecido en el artículo 53.1.d) LPACAP, pondré a disposición de la Administración cuando me sea requerida y que me comprometo a mantener el cumplimiento de estas obligaciones durante el período de tiempo inherente a la autorización concedida en virtud de mi solicitud.
Y para que así conste y surta los efectos previstos en Derecho, lo firmo en {props.city} a {props.date}.
				</Text>
				<br />
				<Text style={styles.text}>
				Fdo. {props.fullName}
				</Text>
				<View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<View style={{ marginTop: 20 }} />
					<Text style={styles.text}>{props.fullName}</Text>
					<Image src={signatureImg} style={{ width: 150, height: 75 }} />
				</View>
	
			</View>
		</Page>
	</Document>
	</>
	);
}
